import { lazy } from "react";
import { RouteProps } from "react-router";
import About from "../containers/About";
import Contact from "../containers/Contact";
import Documents from "../containers/Documents";
import Services from "../containers/Services";

export interface PrivateRouteObject extends RouteProps {
  exact: boolean;
  path: string;
  breadcrumb: string;
  component: any;
  title: string;
}

const Homepage = lazy(() => import("../containers/Home"));

const PUBLIC_ROUTES = [
  {
    exact: true,
    title: "Homepage",
    path: "/",
    component: Homepage,
  },
  {
    exact: true,
    title: "About",
    path: "/about",
    component: About,
  },
  {
    exact: true,
    title: "Services",
    path: "/services",
    component: Services,
  },
  {
    exact: true,
    title: "Contact",
    path: "/contact",
    component: Contact,
  },
  {
    exact: true,
    title: "Documents",
    path: "/documents",
    component: Documents,
  }
];



export { PUBLIC_ROUTES }
